<template>
  <div :style="template.style.surveyBgColor ? {backgroundColor: template.style.surveyBgColor } : {backgroundColor: 'white'}">
    <!-- Navigation -->
    <div :style="template.style.surveyBackground? {backgroundColor: 'var(--bg-filter)'}: ''">
      <HeaderGlobal :secondaryHeader="true" :qtSomos="qtSomos"/>
      <Survey/>
      <FooterGlobal :secondaryFooter="true" :qtSomos="qtSomos"/>
    </div> 
  </div>
</template>

<script>
import SmartSurvey from "./survey/Survey.vue";
import FooterGlobal from "./FooterGlobal";
import HeaderGlobal from "./HeaderGlobal";

export default {
  name: "SurveyPage",
  data: () => ({
    qtSomos: 0
  }),
  components: {
    Survey: SmartSurvey,
    FooterGlobal,
    HeaderGlobal
  },
  computed: {
    template() {
      return this.$store.state.template 
    },
  },

  created() {
    this.qtSomos = this.$store.state.qtUsers;
    this.$gtag.event("Survey", {method: "Google"});
    //this.qtUsers = this.$store.state.qtUsers;
  },
  beforeMount() {
    if (!this.$store.state.surveyStruct.surveyId) {
      this.$nextTick(() => {
        this.$router.push('home')
      })
    }
  },
};
</script>
